export enum Shadows {
  Small = '0 0 0.5rem rgba(0, 0, 0, 0.08), -0.25rem 0.25rem 0.5rem rgba(0, 0, 0, 0.08)',
  Medium = '0 0 0.5rem rgba(0, 0, 0, 0.08), -0.5rem 0.5rem 1rem rgba(0, 0, 0, 0.08)',
  Large = '0 0 0.5rem rgba(0, 0, 0, 0.08), -1rem 1rem 2.5rem rgba(0, 0, 0, 0.08)',
  FixedTop = '0 0 0.5rem rgba(0, 0, 0, 0.08), 0 -1rem 2.5rem rgba(0, 0, 0, 0.08)',
  FixedRight = '0 0 0.5rem rgba(0, 0, 0, 0.08), 1rem 0 2.5rem rgba(0, 0, 0, 0.08)',
  FixedBottom = '0 0 0.5rem rgba(0, 0, 0, 0.08), 0 1rem 2.5rem rgba(0, 0, 0, 0.08)',
  FixedLeft = '0 0 0.5rem rgba(0, 0, 0, 0.08), -1rem 0 2.5rem rgba(0, 0, 0, 0.08)',
}
